const getReturnItemConfig = ({ workflowId, jobId, appId, integrationId, currentWorkflowIntegrationId, embeddedSection, isConnections }) => {
  if (workflowId) {
    if (currentWorkflowIntegrationId) {
      return { label: 'Return to Integration', route: `/embedded/${currentWorkflowIntegrationId}` };
    }
    return { label: 'Return to Workflows', route: '/workflows' };
  }
  if (jobId) {
    return { label: 'Return to Jobs', route: '/jobs' };
  }
  if (appId) {
    return { label: 'Return to Apps', route: '/apps' };
  }
  if (integrationId || isConnections) {
    return embeddedSection === 'sdk' ? { label: 'Return to Embedded SDK', route: '/embedded/sdk' } : { label: 'Return to Embedded API', route: '/embedded/integrations?type=api' };
  }
  return { label: 'Return to Home', route: '/' };
};

export default getReturnItemConfig;
